import store from '@/store'

const Toast = {
  success(message, label = '') {
    store.commit('successMessage/setSuccessMessage', message);
    if (label) {
      store.commit('successMessage/setSuccessLabel', label);
    }
  },
  error(message) {
    store.commit('serverError/setErrorMessage', message);
  }
}

// Install the toast plugin
export default {
  install(Vue) {
    Vue.prototype.$toast = Toast
  }
}
